<script>
	import PerlinProd from "./PerlinProd.svelte";
</script>

<main>
	<PerlinProd />
</main>
